import React, { useEffect, useState } from "react";
import dataService from "../networks/api/service/dataService";
import { useNavigate } from "react-router-dom";
import BarGraph from "./graphs/BarGraph";
import Dashboard from "./DashboardCards/Group";
import VotersAreaGraph from "./DashboardCards/VotersAreaGraph";
import BoothPercentage from "./DashboardCards/BoothPercentage";

function Constituency() {
  const [constituencyList, setconstituencyList] = useState([]);
  const [dashboardCards, setdashboardCards] = useState(null);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [constituencyElection, setconstituencyElection] = useState([]);
  const adminRoleId = localStorage.getItem("adminRoleId");

  const getConstituencyDashboard = async () => {
    try {
      const res = await dataService.constituencyDashboard();
      if (res.code === 200) {
        setdashboardCards(res.data || {}); // Set response data
      }
    } catch (e) {
      console.error(e);
    }
  };

  const fetchData = async () => {
    try {
      const res = await dataService.getVotersConstituency();
      if (res.code === 200) {
        setData(res.data);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const getConstituetionElection = async () => {
    try {
      const response = await dataService.getConstGraph();
      if (response.code === 200) {
        const transformedData = transformElectionData(response?.data);

        setconstituencyElection(transformedData);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const transformElectionData = (data) => {
    const transformedData = [];
    const years = [
      ...new Set(
        data.flatMap((section) =>
          section[Object.keys(section)[0]].map((entry) => entry.year)
        )
      ),
    ];

    years.forEach((year) => {
      const electionDetails = {
        year,
        totalVoter: 0,
        totalPooling: null,
        percentageOfPooling: null,
        totalBooth: 0,
        BJP: 0,
        BJD: 0,
        INC: 0,
      };

      const position = { year, first: 0, second: 0, third: 0, noPosition: 0 };
      const votePercentage = {
        year,
        above45: 0,
        thirtyTo45: 0,
        below30: 0,
        noResult: 0,
      };
      const repeat = {
        year,
        SecondPositionRepeat: 0,
        FirstPositionRepeat: 0,
        ThirdPositionRepeat: 0,
        FortuateDecrease: 0,
        FortuateIncrease: 0,
      };

      data.forEach((section) => {
        const key = Object.keys(section)[0];
        const entry = section[key].find((item) => item.year === year);

        if (entry) {
          if (key === "percentageOfBooth") {
            position.first = entry.first;
            position.second = entry.second;
            position.third = entry.third;
            position.noPosition = entry.noPosition;
          } else if (key === "positionOfBooth") {
            votePercentage.above45 = entry.above45;
            votePercentage.thirtyTo45 = entry.thirtyTo45;
            votePercentage.below30 = entry.below30;
            votePercentage.noResult = entry.noResult;
          } else if (key === "repeatOfBooth") {
            repeat.SecondPositionRepeat = entry.SecondPositionRepeat;
            repeat.FirstPositionRepeat = entry.FirstPositionRepeat;
            repeat.ThirdPositionRepeat = entry.ThirdPositionRepeat;
            repeat.FortuateDecrease = entry.FortuateDecrease;
            repeat.FortuateIncrease = entry.FortuateIncrease;
          }
        }
      });

      transformedData.push({
        year,
        electionDetails,
        position,
        votePercentage,
        repeat,
      });
    });

    return transformedData;
  };
  useEffect(() => {
    fetchData();
    getConstituetionElection();
  }, []);

  const getConstituency = async () => {
    try {
      const res = await dataService.getConstituencyBasedAdmin();
      if (res.code === 200) {
        setconstituencyList(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getConstituency();
    getConstituencyDashboard();
  }, []);

  const handleBarClick = (data) => {
    if (data._id) {
      navigate(`/login/assembly-graph-details/${data._id}`, {
        state: { constituencyName: data.constituencyName },
      });
    }
  };

  return (
    <div
      style={{
        padding: "30px",
        backgroundColor: "#f4f6f9", // Light grey background
        borderRadius: "12px",
        boxShadow: "0 6px 15px rgba(0, 0, 0, 0.1)",
        minHeight: "100vh",
      }}
    >
      {/* Dashboard Cards */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "20px",
          padding: "20px 0",
          justifyContent: "center",
        }}
      >
        <Dashboard
          grievanceList="grievance-list"
          assignedGrievance="constituency-grievance"
          data={dashboardCards}
        />
      </div>
      {/* <VotersAreaGraph loading={loading} data={data} />
      <BoothPercentage electionDetails={constituencyElection} /> */}

      {/* Bar Graph */}
      {/* <div
        style={{
          marginTop: "40px",
          padding: "20px",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 6px 15px rgba(0, 0, 0, 0.1)",
        }}
      >
        <BarGraph
          data={constituencyList}
          xKey="constituencyName"
          title="Parliament Details"
          bars={[
            {
              key: "totalPopulation",
              color: "#8884d8",
              name: "Total Population",
            },
            {
              key: "totalMaleVoter",
              color: "#82ca9d",
              name: "Male Voters",
            },
            {
              key: "totalFemaleVoter",
              color: "#ffc658",
              name: "Female Voters",
            },
          ]}
          onBarClick={handleBarClick}
        />
      </div> */}
    </div>
  );
}

export default Constituency;
